<template>
    <div v-if="dashboard_data.total_websites!=null">
      <CRow >
        <CCol col="12"><strong>اطلاعات روز</strong></CCol>
        <CCol  col="2" >
          <CWidgetDropdown
              class="box_item_center"
              color="danger"
              style="margin-bottom:3px;height:80px;place-items: center;text-align: center"

              :header="dashboard_data.tickets_non_answered.toString()"
              text="تیکت های بدون پاسخ">
            <template #default>

            </template>
            <template #footer>

              <!--          <CChartLineSimple-->
              <!--            pointed-->
              <!--            class="mt-3 mx-3"-->
              <!--            style="height:70px"-->
              <!--            :data-points="[65, 59, 84, 84, 51, 55, 40]"-->
              <!--            point-hover-background-color="primary"-->
              <!--            :label="$t('components.totalSales')"-->
              <!--            labels="months"-->
              <!--          />-->
            </template>
          </CWidgetDropdown>
        </CCol>
        <CCol col="2">
          <CWidgetDropdown
              style="margin-bottom:0;height:80px;place-items: center;text-align: center"
              class="box_item_center"
              color="success"
              :header="get_currency(today_total_payments)"
              text="پرداختی امروز"
          >
            <template #default>
            </template>
            <template #footer>

            </template>
          </CWidgetDropdown>
        </CCol>

        <CCol col="2">
          <CWidgetDropdown
              class="box_item_center"
              style="margin-bottom:0;height:80px;place-items: center;text-align: center;background:#39f"
              :header="dashboard_data.today_domains.toString()"
              text="دامنه های امروز"
          >
            <template #default>
            </template>
            <template #footer>

            </template>
          </CWidgetDropdown>
        </CCol>
        <CCol col="2">
          <CWidgetDropdown
              style="margin-bottom:3px;height:80px;place-items: center;text-align: center"
              class="box_item_center"
              color="info"
              :header="dashboard_data.today_websites.toString()"
              text="سایت های امروز"
          >

            <template #default>

            </template>
            <template #footer>

            </template>
          </CWidgetDropdown>
        </CCol>


      </CRow>
<CRow>
  <CCol col="12"><strong>اطلاعات کل</strong></CCol>

  <CCol col="2">
    <CWidgetDropdown
        style="margin-bottom:0;height:80px;place-items: center;text-align: center"
        class="box_item_center"
        color="info"
        :header="dashboard_data.total_domains"
        text="دامنه های کل">
      <template #default>


      </template>
      <template #footer>

      </template>
    </CWidgetDropdown>
  </CCol>
  <CCol col="2">
    <CWidgetDropdown
        style="margin-bottom:0;height:80px;place-items: center;text-align: center"
        class="box_item_center"
        color="info"
        :header="dashboard_data.total_users"
        text="تعداد کاربران">
      <template #default>


      </template>
      <template #footer>

      </template>
    </CWidgetDropdown>
  </CCol>
  <CCol col="2">
    <CWidgetDropdown
        style="margin-bottom:3px;height:80px;place-items: center;text-align: center"
        class="box_item_center"
        color="primary"
        :header="dashboard_data.total_websites"
        text="وبسایت های کل"
    >

      <template #default>

      </template>
      <template #footer>

      </template>
    </CWidgetDropdown>
  </CCol>
  <CCol col="2">
    <CWidgetDropdown
        style="margin-bottom:3px;height:80px;place-items: center;text-align: center"
        class="box_item_center"
        color="primary"
        :header="JSON.parse(dashboard_data.reseler).number_of_domains"
        text="دامنه های ثبت شده"
    >

      <template #default>

      </template>
      <template #footer>

      </template>
    </CWidgetDropdown>
  </CCol>
  <CCol col="2">
    <CWidgetDropdown
        style="margin-bottom:3px;height:80px;place-items: center;text-align: center"
        class="box_item_center"
        color="danger"
        :header="JSON.parse(dashboard_data.reseler).balance"
        text="بالانس نمایندگی ایرنیک"
    >

      <template #default>

      </template>
      <template #footer>

      </template>
    </CWidgetDropdown>
  </CCol>
</CRow>
    </div>
</template>

<script>

    import {bus} from "../main";
    import axios from "axios";

    export default {
        name: 'Dashboard',
        components: {

        },
        data() {
            return {
dashboard_data:{},
              today_total_payments:0,
            }
        },
        computed: {

        },
        mounted() {

            this.get_dashboard_data();

        },
        methods: {
            get_dashboard_data() {
                var self = this;

                const formData = new FormData();

                axios.post('/admin/dashboard_data', formData, {}).then(function (response) {


                    self.dashboard_data = response.data;

                    self.dashboard_data.total_payments.forEach(function (val){
                    self.today_total_payments +=val.price.total_price
                  })
                  self.today_total_payments +=self.dashboard_data.total_payments_extra

document.getElementById("ticket_badge").innerText = self.dashboard_data.tickets_non_answered
                  if(JSON.parse(self.dashboard_data.reseler).balance < 10){
                    self.$root.modal_component.show_danger_modal("اخطار", "حساب نمایندگی ایرنیک را شارژ کنید");

                  }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },




        },
    }
</script>
<style>
    .bg-revenue .nav-link.active {
        background: #3399FF;
        color: white;
    }

    .bg-sale .nav-link.active {
        background: #f9b115;
        color: white;
    }

    .bg-profit .nav-link.active {
        background: #2eb85c;
        color: white;
    }
</style>
